import { Text } from '@change/ds-core-ui';

import { Badge } from './Badge';
import { Button } from './Button';
import type { ItemPriceProps } from './ItemPrice.types';

export const ItemPrice: React.FC<ItemPriceProps> = ({
	value,
	badge,
	metaText,
	label,
	selected,
	localizedValue,
	onClick,
	'data-qa': dataQa,
}: ItemPriceProps) => {
	return (
		<Button selected={!!selected} onClick={() => onClick(value)} data-qa={dataQa}>
			<div className="w-full">
				<Badge position="top" badge={badge} />
				<div className="flex flex-row justify-between pb-1.5">
					<div className="flex flex-row gap-2">
						{metaText && (
							<Text variant="body" size="medium" className="text-typography-weak line-through">
								{metaText}
							</Text>
						)}
						<Text variant="body" size="medium" fontWeight="bold">
							{label}
						</Text>
					</div>
					{localizedValue && (
						<Text variant="body" size="medium" fontWeight="bold">
							{localizedValue}
						</Text>
					)}
				</div>
				<Badge position="bottom" badge={badge} />
			</div>
		</Button>
	);
};
